module.exports = __webpack_public_path__ + "img/3.6e97bbb5.svg";